import type { Interceptor } from '@connectrpc/connect'
import { getBearerForRequest } from './fetch-rpc'

/**
 * Authentication interceptor for connect-web transports.
 * Adds the Authorization header to RPC requests, except same-origin calls on
 * first-party session hosts made by a logged-in identity: there the HttpOnly
 * `fm_session` cookie authenticates the request. Anonymous identities have no
 * cookie, so their bearer is attached everywhere.
 * Runs after `proxyInterceptor`, so `req.url` is already the resolved URL.
 */
export const authInterceptor: Interceptor = next => async req => {
  const bearer = await getBearerForRequest(req.url)
  if (bearer) {
    req.header.set('Authorization', `Bearer ${bearer}`)
  }
  return next(req)
}
